export function doesAccountRequireCompletion(user = {}) {
  return !user.fullname;
//  return !user.email || !user.fullname;
}
